import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '@ajgre/toolkit';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 're-modal',
  imports: [CommonModule, ButtonComponent],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {
  private modal = inject(NgbActiveModal);

  @Input() target!: string;
  @Input() title!: string;
  @Input() buttonTemplate: TemplateRef<unknown> | null = null;

  onCancel() {
    this.modal.close(true);
  }
}
